import $ from 'jquery';

class SiteSearch {
  constructor() {
    setTimeout(this.LoadActiveResults(), 750);
    this.searchContainer = $(".allSearch__container");
    this.resultsDiv = $(".allSearch__results");
    this.showButton = $(".allSearch__link");
    this.loadMoreButton = $(".allSearch__load a");
    this.events();
    this.isSpinnerVisible = false;
    this.previousValue;
    this.typingTimer;
    this.loadInfo;
  }

  events() {
    this.showButton.on("click", this.fetchLogic.bind(this));
    this.loadMoreButton.on("click", this.getMoreResults.bind(this));
  }

  fetchLogic(e) {
    if ($(this)) {
      clearTimeout(this.typingTimer);

      let target = e.target;
      target = target.getAttribute('href');
      target = target.substring(1, target.length);
      if (this.showButton) {
        if (!this.isSpinnerVisible) {
          this.resultsDiv.html(`
            <div class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>`);
          this.isSpinnerVisible = true;
        }
        this.typingTimer = setTimeout(this.getResults(target), 750);
        this.loadMoreButton.attr("data-url", `term=${target}&page=2&number=20`);

      } else {
        this.resultsDiv.html('');
        this.isSpinnerVisible = false;
      }
    }
  }

  getResults(personaValue) {
    let i = 0;
    let page = 1;
    let per_page = 30;
    let searchTerm = $(".allSearch__container").attr("data-search");
    if (personaValue === 'articles' || personaValue === 'all') {
      personaValue = 'pagesearch';
    }

    //$.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/'+personaValue+'?term=' + searchTerm + '&page=1&number=20', (results) => {
      $.when($.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/'+personaValue+'?term=' + searchTerm + '&page=1&number=20'),
        $.getJSON(MaRS_DATA.site_url + '/wp-content/themes/marsdd-chapter/includes/mondayVc/get_request.php?page='+page+'&per_page='+per_page+'&title='+searchTerm)).then((results, careers) => {

      let currentPage = results[0].current_page;

      if (personaValue === 'services') {
        this.resultsDiv.html(`
            ${results[0].serviceInfo.length ? '<div class="row">' : '<p>No Service information matches that search.</p>'}
              ${results[0].serviceInfo.map(item => `<div class="col col-12 col-md-6 col-lg-4"><a href="${(item.featured_item === true || item.external_page === true ) ? (item.featured_item_link ? item.featured_item_link : item.external_link) : item.permalink}" ${item.external_page === true ? 'target="_blank"' : ''} 
                class="allServices__card ${item.featured_item === true ? 'allServices__featured' : ''}" data-enter="fade" data-enter-delay="${i=i+50}">
                <h3>${item.title}</h3>
                ${item.description}
                <i class="allServices__arrow"><svg xmlns="http://www.w3.org/2000/svg" width="45" height="10" viewBox="0 0 45 10">
                  <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                      <path d="M1 5h42M40 1l4 4-4 4"/>
                  </g></svg>
                </i>
                ${item.external_page ? '<i class="allServices__external"></i>' : ''}</a></div>`).join('')}
            ${results[0].serviceInfo.length ? '</div>' : ''}
          </div>
        `);
      }

      else if (personaValue === 'articles') {
        this.resultsDiv.html(`
            ${results[0].marsArticles.length ? '<div class="allSearch__row">' : '<p>No result matches that search.</p>'}
              ${results[0].marsArticles.map(item => `<a href="${item.permalink}" title="${item.title}" class="allSearch__card">
                <h4>${item.title}</h4>
                </a>`).join('')}
            ${results[0].marsArticles.length ? '</div>' : ''}
          </div>
      `);
      }

      else if (personaValue === 'careers') {
        this.resultsDiv.html(`
            ${careers[0].items.length ? '<div class="row no-gutters allCareers__row">' : '<p>No Career information matches the search term.</p>'}
              ${careers[0].items.map(item => `
                
                <a class="col-12 col-md-12 allCareers__career" target="_blank" href="${item.url}">
                  <div class="row no-gutters">
                    <div class="col-12 col-md-7 allCareers__jobTitle">
                      <h3 class="allCareers__title">${item.title}</h3>
                      <span class="allCareers__company">${item.company.name}</span>
                      <span class="allCareers__venture"><span data-tooltip="A company supported by MaRS Venture Services.">Venture</span></span>
                    </div>
                    
                    <div class="col-12 col-md-3 allCareers__details">
                      <span class="allCareers__location">${item.locations}</span>
                      <!--<span class="allCareers__type"</span>-->
                    </div>
                    <div class="col-12 col-md-2 allCareers__link">
                      <span class="button button--tertiary">Learn more</span>
                      <i class="allCareers__external"></i>
                    </div>
                  </div>
                </a>
            `).join('')}
            ${careers[0].items.length ? '</div>' : ''}
      `);
        this.loadMoreButton.hide();
      }

      else if (personaValue === 'events') {

        this.resultsDiv.html(`
            ${results[0].eventInfo.length ? '<div class="row allEvents__row eventSection__boxes">' : '<p>No Event information matches the search term.</p>'}
              ${results[0].eventInfo.map(item => `<div class="col-12 col-md-4 col-sm-4 allEvents__event ${item.add_event_cta === true ? "event__cta-wrapper":""}">
                <div class="eventSection__event">
                
                  ${item.add_event_cta === true ? `
                  <a href="${item.event_cta_link}"}>

                    <div class="eventSection__event-cta">
                      ${item.event_cta_content}
                      
                      <i class="event__arrow"><svg xmlns="http://www.w3.org/2000/svg" width="45" height="10" viewBox="0 0 45 10">
                      <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                          <path d="M1 5h42M40 1l4 4-4 4"/></g></svg></i>
                    </div>
                  </a>` :

          `<a href="${item.external_link ? item.external_link : item.permalink}" ${item.external_link ? `target="_blank"` : ``}>
                  
                  <div class="eventSection__event-featuredImg" style="background:url(${item.event_image}) no-repeat;"></div>
                  <div class="eventSection__event-contentWrapper">
                      <p class="eventSection__event-sponsor">${item.sponsor}</p>
                      <p class="bold">${item.title}</p>
                      <ul>
                          <li class="marsCal__icon"><span>${item.start_date}</span></li>
                          ${item.start_time ? `<li class="marsClock__icon"><span>${item.start_time} ${item.end_time ? ` - ${item.end_time}` : ``}</span></li>` : ''}
                          <li class="marsPin__icon"><span>${item.location}</span></li>
                      </ul>
                  </div>
             
                </a>`}
                  
            </div></div>`).join('')}
            ${results[0].eventInfo.length ? '</div>' : ''}
        `);
      }

      else {

        this.resultsDiv.html(`
            ${results[0].marsResults.length ? '<div class="allSearch__row">' : '<p>No result matches that search.</p>'}
              ${results[0].marsResults.map(item => `<a href="${(item.featured_item === true || item.external_page === true ) ? (item.featured_item_link ? item.featured_item_link : item.external_link) : item.permalink}" ${item.external_page === true ? 'target="_blank"' : ''} title="${item.title}" class="allSearch__card">
                <h4>${item.title}</h4>
                </a>`).join('')}
            ${results[0].marsResults.length ? '</div>' : ''}
          </div>
        `);

      }

      this.isSpinnerVisible = false;
      this.loadMoreButton.attr("data-url", `${personaValue}?term=${searchTerm}&page=2&number=20`);
      `${(results[0].max_pages == currentPage || results[0].max_pages == 0) ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
    }).fail(function(jqXHR, textStatus, error) {
    });

  }


  LoadActiveResults() {

    if ($(".allSearch__container").length) {

      let searchTerm = $(".allSearch__container").attr("data-search");
      let page = 1;
      let per_page = 30;

      if (!this.isSpinnerVisible) {
        $(".allSearch__results").html(`
            <div class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>`);
        this.isSpinnerVisible = true;
      }

      if ($(".allSearch__results").length) {
        //$.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/pagesearch?term=' + searchTerm + '&page=1&number=-1', (results) => {
        $.when($.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/pagesearch?term=' + searchTerm + '&page=1&number=-1'),
          $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/services?term=' + searchTerm + '&page=1&number=-1'),
          $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/events?term=' + searchTerm + '&page=1&number=-1'),
          /*$.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/careers?term=' + searchTerm + '&page=1&number=-1'),*/
          $.getJSON(MaRS_DATA.site_url + '/wp-content/themes/marsdd-chapter/includes/mondayVc/get_request.php?page='+page+'&per_page='+per_page+'&title='+searchTerm)).then((results, services, events, careers) => {


          let currentPage = results[0].current_page;
          let allTotal = results[0].total_found;
          let servicesTotal = services[0].total_found;
          let eventsTotal = events[0].total_found;
          let careerTotal = careers[0].meta;
          careerTotal = careerTotal.total;
          let articleTotal = results[0].marsArticles.length;
          $(".allSearch__link span.all, span.countTotal").html(`${allTotal}`);
          $(".allSearch__link span.articles").html(`${articleTotal}`);

          this.resultsDiv.html(`
            ${results[0].marsResults.length ? '<div class="allSearch__row">' : '<p>No result matches that search.</p>'}
              ${results[0].marsResults.slice(0, 20).map(item => `<a href="${(item.featured_item === true || item.external_page === true ) ? (item.featured_item_link ? item.featured_item_link : item.external_link) : item.permalink}" ${item.external_page === true ? 'target="_blank"' : ''} title="${item.title}" class="allSearch__card">
                <h4>${item.title}</h4>
                </a>`).join('')}
            ${results[0].marsResults.length ? '</div>' : ''}
          </div>
          `);

          $(".allSearch__link span.services").html(`${servicesTotal}`);
          $(".allSearch__link span.events").html(`${eventsTotal}`);
          //(total === undefined || total === null) ? total = 0 : '';
          $(".allSearch__link span.careers").html(`${careerTotal}`);

          this.isSpinnerVisible = false;
          this.loadMoreButton.attr("data-url", `pagesearch?term=${searchTerm}&page=2&number=20`);
          `${(results[0].max_pages == currentPage || results[0].marsResults.length == 0 ) ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
        }).fail(function (jqXHR, textStatus, error) {
        });


      }

      /*
      $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/services?term=' + searchTerm + '&page=1&number=-1', (results) => {
        let total = results.total_found;
        $(".allSearch__link span.services").html(`${total}`);
      }).fail(function (jqXHR, textStatus, error) {
      });

      $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/events?term=' + searchTerm + '&page=1&number=-1', (results) => {
        let total = results.total_found;
        $(".allSearch__link span.events").html(`${total}`);
      }).fail(function (jqXHR, textStatus, error) {
      });

      $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/careers?term=' + searchTerm + '&page=1&number=-1', (results) => {
        let total = results.careerInfo.length;
        (total === undefined || total === null) ? total = 0 : '';
        $(".allSearch__link span.careers").html(`${total}`);
      }).fail(function (jqXHR, textStatus, error) {
      });
      */



    }

  }


  getMoreResults(e) {
    e.preventDefault();
    this.loadInfo = this.loadMoreButton.attr("data-url");

    let i = 0;
    let currentType = this.loadInfo.split('?');
    let searchTerm = currentType[1].split('&');
    searchTerm = searchTerm[0].split('=');
    //console.log(searchTerm[1]);

    if (!this.isSpinnerVisible) {
      this.resultsDiv.append(`
        <div class="sk-double-bounce">
          <div class="sk-child sk-double-bounce1"></div>
          <div class="sk-child sk-double-bounce2"></div>
        </div>`);
      this.isSpinnerVisible = true;
    }

    $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/' + this.loadInfo, (results) => {
      let currentPage = results.current_page;

      if (currentType[0] === 'services') {
        this.resultsDiv.append(`
            ${results.serviceInfo.length ? '<div class="row">' : '<p>No Service information matches that search.</p>'}
              ${results.serviceInfo.map(item => `<div class="col col-12 col-md-6 col-lg-4"><a href="${(item.featured_item === true || item.external_page === true ) ? (item.featured_item_link ? item.featured_item_link : item.external_link) : item.permalink}" ${item.external_page === true ? 'target="_blank"' : ''} 
                class="allServices__card ${item.featured_item === true ? 'allServices__featured' : ''}" data-enter="fade" data-enter-delay="${i=i+50}">
                <h3>${item.title}</h3>
                ${item.description}
                <i class="allServices__arrow"><svg xmlns="http://www.w3.org/2000/svg" width="45" height="10" viewBox="0 0 45 10">
                  <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                      <path d="M1 5h42M40 1l4 4-4 4"/>
                  </g></svg>
                </i>
                ${item.external_page ? '<i class="allServices__external"></i>' : ''}</a></div>`).join('')}
            ${results.serviceInfo.length ? '</div>' : ''}
          </div>
        `);
      }
      else if (currentType[0] === 'articles') {
        this.resultsDiv.append(`
            ${results.marsArticles.length ? '<div class="allSearch__row">' : '<p>No result matches that search.</p>'}
              ${results.marsArticles.map(item => `<a href="${item.permalink}" title="${item.title}" class="allSearch__card">
                <h4>${item.title}</h4>
                </a>`).join('')}
            ${results.marsArticles.length ? '</div>' : ''}
          </div>
      `);
      }

      /*else if (currentType[0] === 'careers') {
        if (results.careerInfo.length != 0) {
          this.resultsDiv.append(`
            ${(results.careerInfo.length || results.careerInfo.length !== 0 ) ? '<div class="row no-gutters allCareers__row">' : '<p>No Career information matches the search term.</p>'}
            
              ${results.careerInfo.map(item => `
                
                <a class="col-12 col-md-12 allCareers__career" href="${item.open_external === true ? item.external_link : item.permalink}" ${item.open_external === true ? 'target="_blank"' : ''}>
                  <div class="row no-gutters">
                    <div class="col-12 col-md-7 allCareers__jobTitle">
                      <h3 class="allCareers__title">${item.title}</h3>
                      <span class="allCareers__company">${item.company_name}</span>
                      ${item.mars_venture ? '<span class="allCareers__venture">Venture</span>' : ''}
                    </div>
                    
                    <div class="col-12 col-md-3 allCareers__details">
                      <span class="allCareers__location">${item.company_location}</span>
                      <span class="allCareers__type">${item.career_types[0]}</span>
                    </div>
                    <div class="col-12 col-md-2 allCareers__link">
                      <span class="button button--tertiary">Learn more</span>
                      ${item.open_external ? '<i class="allCareers__external"></i>' : ''}
                    </div>
                  </div>
                </a>
            `).join('')}
            ${results.careerInfo.length ? '</div>' : ''}
          `);
        }
      }*/

      else if (currentType[0] === 'events') {

        this.resultsDiv.append(`
            ${results.eventInfo.length ? '<div class="row allEvents__row eventSection__boxes">' : '<p>No Event information matches the search term.</p>'}
              ${results.eventInfo.map(item => `<div class="col-12 col-md-4 col-sm-4 allEvents__event ${item.add_event_cta === true ? "event__cta-wrapper":""}">
                <div class="eventSection__event">
                
                  ${item.add_event_cta === true ? `
                  <a href="${item.event_cta_link}"}>

                    <div class="eventSection__event-cta">
                      ${item.event_cta_content}
                      
                      <i class="event__arrow"><svg xmlns="http://www.w3.org/2000/svg" width="45" height="10" viewBox="0 0 45 10">
                      <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                          <path d="M1 5h42M40 1l4 4-4 4"/></g></svg></i>
                    </div>
                  </a>` :

          `<a href="${item.external_link ? item.external_link : item.permalink}" ${item.external_link ? `target="_blank"` : ``}>
                  
                  <div class="eventSection__event-featuredImg" style="background:url(${item.event_image}) no-repeat;"></div>
                  <div class="eventSection__event-contentWrapper">
                      <p class="eventSection__event-sponsor">${item.sponsor}</p>
                      <p class="bold">${item.title}</p>
                      <ul>
                          <li class="marsCal__icon"><span>${item.start_date}</span></li>
                          ${item.start_time ? `<li class="marsClock__icon"><span>${item.start_time} ${item.end_time ? ` - ${item.end_time}` : ``}</span></li>` : ''}
                          <li class="marsPin__icon"><span>${item.location}</span></li>
                      </ul>
                  </div>
             
                </a>`}
                  
            </div></div>`).join('')}
            ${results.eventInfo.length ? '</div>' : ''}
        `);
      }

      else {
        this.resultsDiv.append(`
            ${results.marsResults.length ? '<div class="allSearch__row">' : '<p>No result matches that search.</p>'}
              ${results.marsResults.map(item => `<a href="${(item.featured_item === true || item.external_page === true ) ? (item.featured_item_link ? item.featured_item_link : item.external_link) : item.permalink}" ${item.external_page === true ? 'target="_blank"' : ''} title="${item.title}" class="allSearch__card">
                <h4>${item.title}</h4>
                </a>`).join('')}
            ${results.marsResults.length ? '</div>' : ''}
          </div>
        `);
      }

      $('.sk-double-bounce').remove();
      this.isSpinnerVisible = false;
      this.loadMoreButton.attr("data-url", `${currentType[0]}?term=${searchTerm[1]}&page=${parseInt(currentPage) + 1}&number=20`);
      `${results.max_pages == currentPage ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
    }).fail(function(jqXHR, textStatus, error) {
    });
  }

}

export default SiteSearch;